import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import toast, { Toaster } from 'react-hot-toast';
import get from 'lodash/get';

import { useInitialPasswordToken } from '@project/react-queries';
import { LoginProps, ResetPasswordProps } from '@project/types';
import { decodedToken, userAuthService } from '@project/services';
import { FormContainer, InitialPasswordForm } from '@project/components';
import { setUserRole } from '@project/reducers/userRole-reducer/userRole.actions';
import { useRoleRedirect } from '@project/hooks';
import { useAppDispatch } from '@project/reducers/store';

const InitialPasswordScreen: React.FC = () => {
  const location = useLocation();
  const [token, setToken] = useState('');
  const redirectByRole = useRoleRedirect();
  const dispatch = useAppDispatch();

  const getInitialPasswordToken = useInitialPasswordToken(
    new URLSearchParams(location.search).get('email'),
  );

  const onSubmit = async (formData: ResetPasswordProps) => {
    const insertToken = { ...formData };
    insertToken.token = token;
    await userAuthService.resetPassword(insertToken);

    const loginData: LoginProps = {
      username: formData.email,
      password: formData.password,
      remember: false,
    };

    return userAuthService.login(loginData);
  };

  const onSuccess = async () => {
    toast.success('Successfully Set Password');
    const role = decodedToken.getRole();
    await dispatch(setUserRole(role));
    redirectByRole(role);
  };

  const initialValues: ResetPasswordProps = {
    password: '',
    confirmPassword: '',
    token: new URLSearchParams(location.search).get('token') || '',
    email: new URLSearchParams(location.search).get('email') || '',
  };

  useEffect(() => {
    getInitialPasswordToken.refetch().then((result) => {
      if (result.isError) {
        toast.error(
          `${get(result, 'error.detail', 'Something went wrong, please try again later')}`,
          {
            duration: 30000,
          },
        );
      } else {
        setToken(result.data);
      }
    });
  }, []);

  return (
    <>
      <FormContainer>
        <Toaster position="top-center" />
        <InitialPasswordForm
          initialValues={initialValues}
          submitForm={onSubmit}
          onSuccess={onSuccess}
          onFailure={() => null}
        />
      </FormContainer>
    </>
  );
};

export default InitialPasswordScreen;
